import { useEffect, useRef, useState } from "react";

/**
 * IntersectionObserver hook — returns [ref, hasEntered] for scroll-reveal animations.
 * `once = true` (default) means the animation triggers once and stays.
 */
export default function useInView(options = {}, once = true) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px", ...options }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [once]);

  return [ref, inView];
}
